import L from "leaflet";
import styled from "styled-components";
import { LayerMarkers, PolyLine } from "../data/layers";
// @ts-ignore
import { hsl2rgb } from '@youc/colorconvert';


export const redH = 359;
export const key = 'fsbnWk7i4Arhs1UYNQPu';
export const keymb = 'pk.eyJ1IjoiY29kZTJiMyIsImEiOiJja3V5aHc4YzIzOWRpMm9xcnN4eThxMWMzIn0.2RZVBxemtLc2o63uvPdKmA';
export const css = (h: number, s: number, l: number) => {
  let hsl = [Math.round(h), Math.round(s), Math.round(l)];
  let rgb = hsl2rgb(...hsl);
  let rr = hsl2rgb(359, 100, 50);
  return 'rgb(' + rgb.map((x: number) => x).join(', ') + ')';
};
// Map container
export const StyledMap = styled.div`
  width: 100%;
  height: 100vh;
  z-index: 1;
`;
// Map attributions
export const ATTR_OSM = 'Map data &copy; <a href="http://openstreetmap.org/">OpenStreetMap</a> contributors', ATTR_OVERPASS = 'POI via <a href="http://www.overpass-api.de/">Overpass API</a>';

// Map props
export interface MapProps {
  latitude: number;
  longitude: number;
  fullTitle: string;
  activeMarkers: LayerMarkers[];
  activeWays?: PolyLine[] | null;
  activeRoutes?: any | null;
  bikeWayVisibility?: Record<string, boolean>;
  setBounds: (bounds: string) => void;
  control?: L.Control | any;
  onMapReady?: (map: L.Map) => void;
}
